import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { phaseChange, reroute } from '../../../../actions/Buy'
import {
  findomesticResetPin,
  findomesticUpdate,
  getContratti,
} from '../../../../actions/buy/Findomestic'
import {
  getFinanziamentoAssicurato,
  getFinanziamentoNonAssicurato,
} from '../../../../utils/firmaUtils'
import OrderRecoveryBanner from '../../../dumb/OrderRecoveryBanner'
import BuyButton from '../../dumb/BuyButton'
import BuyMiniCart from '../../dumb/BuyMiniCart'
import BuyTextInput from '../../dumb/BuyTextInput'
import { preparaValoriLogistica } from '../../utils'

class FindomestiCreaPin extends Component {
  constructor(props) {
    super(props)
    this.state = {
      pinInputError: '',
      confermaPinInputError: '',
      otpInputError: '',
    }
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentWillMount() {
    if (
      !('token' in this.props.customer) ||
      this.props.customer.token === null ||
      this.props.customer.token.length === 0
    ) {
      this.props.reroute('/register')
    }
  }

  componentDidMount() {
    this.props.phaseChange({ phase: 120 })
  }

  handleSubmit() {
    const t = this
    return () => {
      if (t.props.findomestic.pin === t.props.findomestic.conferma_pin) {
        t.props.getContratti().then(() => {
          t.props.reroute('/contratto-infocert')
        })
      }
    }
  }

  render() {
    const { product } = this.props
    const valoriLogistica = preparaValoriLogistica(
      this.props.pricing.total,
      this.props.logistica
    )
    const h1 = 'Firma Digitale: sottoscrivi i documenti e concludi la richiesta'
    const t = this
    return (
      <div className="FindomesticInfocertFirma sellout-findomestic">
        <section className="relative process" id={'FindomesticCreaPin'}>
          <div className="process__header">
            <h1 className="process__title">{h1}</h1>
          </div>
          <div className={'messages warning'}>
            <div className={'container'}>
              <OrderRecoveryBanner />
            </div>
          </div>
          <div className="user-informations">
            <div className="container_small">
              <div className="process__column process__column__left">
                <h1>Crea Pin</h1>
                <p>
                  <b>
                    Scegli un PIN personale di 8 cifre e memorizzalo bene, ti
                    servir&agrave; a breve per firmare il contratto.
                  </b>
                </p>
                <p>
                  Inserisci anche l'OTP (one-time-password) che riceverai a
                  breve sul tuo numero di cellulare{' '}
                  <b>{this.props.findomestic.meta.mobile}</b>, come da te
                  precedentemente indicato.
                </p>
                <div className="space-50"></div>
                <ul className={'data-form x-small'}>
                  <li className={`${this.state.pinInputError} wide`}>
                    <BuyTextInput
                      classes="input-data form-input big"
                      defaultValue={this.props.findomestic.pin}
                      label={'Inserisci PIN (8 cifre da te scelte)'}
                      onInput={event => {
                        t.props.findomesticUpdate({
                          pin: `${event.target.value}`,
                        })
                      }}
                      placeholder={'Scrivi il PIN'}
                      type={'number'}
                      update={event => {
                        if (event.target.value.length !== 8) {
                          t.setState({ pinInputError: 'is-error' })
                        } else if (!/^\d+$/.test(event.target.value)) {
                          t.setState({ pinInputError: 'is-error' })
                        } else {
                          t.setState({ pinInputError: '' })
                        }
                      }}
                    />
                  </li>
                  <li className={`${this.state.confermaPinInputError} wide`}>
                    <BuyTextInput
                      classes="input-data form-input big"
                      defaultValue={this.props.findomestic.conferma_pin}
                      label={'Conferma PIN'}
                      onInput={event => {
                        t.props.findomesticUpdate({
                          conferma_pin: `${event.target.value}`,
                        })
                      }}
                      placeholder={'Scrivi la conferma del PIN'}
                      type={'number'}
                      update={event => {
                        if (
                          event.target.value.length !== 8 ||
                          `${event.target.value}` !== t.props.findomestic.pin
                        ) {
                          t.setState({ confermaPinInputError: 'is-error' })
                        } else if (!/^\d+$/.test(event.target.value)) {
                          t.setState({ confermaPinInputError: 'is-error' })
                        } else {
                          t.setState({ confermaPinInputError: '' })
                        }
                      }}
                    />
                  </li>
                  <li className={`${this.state.otpInputError} wide`}>
                    <BuyTextInput
                      classes="input-data form-input big"
                      defaultValue={this.props.findomestic.otp}
                      label={'Inserisci OTP (codice ricevuto via sms)'}
                      onInput={event => {
                        t.props.findomesticUpdate({
                          otp: `${event.target.value}`,
                        })
                      }}
                      placeholder={'Scrivi il codice OTP'}
                      type={'number'}
                      update={event => {
                        if (!/^\d+$/.test(event.target.value)) {
                          t.setState({ otpInputError: 'is-error' })
                        } else {
                          t.setState({ otpInputError: '' })
                        }
                      }}
                    />
                  </li>
                  <p className="small">
                    Non ti arriva l'OTP? Se il numero di cellulare{' '}
                    {this.props.findomestic.meta.mobile} &egrave; corretto
                    <a
                      onClick={() => {
                        this.props.findomesticResetPin({})
                        this.props.reroute('/thank-you-findomestic')
                      }}
                    >
                      &nbsp;clicca qui&nbsp;
                    </a>
                    per iniziare nuovamente il processo di firma digitale oppure
                    contatta il nostro servizio clienti allo 02.800.29
                  </p>
                  <div className="space-20"></div>
                </ul>
                <div className={'buttons_set center no-brd more-pd'}>
                  <BuyButton
                    classes={`btn btn-primary ${
                      this.props.fetching ? ' btn-disabled' : ''
                    }`}
                    label={'Prosegui'}
                    update={this.handleSubmit()}
                  />
                </div>
              </div>
              <div className="process__column process__column__right">
                <BuyMiniCart
                  {...valoriLogistica}
                  acconti={this.props.ordine.acconti}
                  agevolazione_iva_104={
                    this.props.customer.agevolazione_iva_104
                  }
                  finanziamento={getFinanziamentoAssicurato(
                    this.props.findomestic,
                    this.props.ordine,
                    this.props.financements
                  )}
                  finanziamentoNonAssicurato={getFinanziamentoNonAssicurato(
                    this.props.findomestic,
                    this.props.ordine,
                    this.props.financements
                  )}
                  idAuto={product.id_auto}
                  km={product.km}
                  ordine={this.props.ordine}
                  ownership={product.passaggio_proprieta_totale_generale}
                  paymentMethod={this.props.paymentMethod}
                  price={product.prezzo_sellout}
                  product={product}
                  sconto={this.props.ordine.sconto}
                  serviziAssicurativiSelezionati={
                    this.props.findomestic.servizi_assicurativi_selezionati
                  }
                  totalone={this.props.ordine.totale}
                  year={product.anno}
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

FindomestiCreaPin.defaultProps = {}

FindomestiCreaPin.propTypes = {
  product: PropTypes.object,
  ordine: PropTypes.object,
  pricing: PropTypes.object,
  logistica: PropTypes.object,
  fetching: PropTypes.bool,
  customer: PropTypes.object,
  findomestic: PropTypes.object,
  reroute: PropTypes.func,
  phaseChange: PropTypes.func,
  findomesticUpdate: PropTypes.func,
  getContratti: PropTypes.func,
  findomesticResetPin: PropTypes.func,
  paymentMethod: PropTypes.string,
  financements: PropTypes.object,
}

const mapStateToProps = state => ({
  pricing: state.pricing,
  product: state.product,
  ordine: state.ordine,
  findomestic: state.findomestic,
  logistica: state.logistica,
  customer: state.customer,
  fetching: state.ui.fetching,
  paymentMethod: state.payment.method,
  financements: state.financements,
})

const mapDispatchToProps = dispatch => ({
  reroute: payload => dispatch(reroute(payload)),
  phaseChange: payload => dispatch(phaseChange(payload)),
  findomesticUpdate: payload => dispatch(findomesticUpdate(payload)),
  findomesticResetPin: payload => dispatch(findomesticResetPin(payload)),
  getContratti: () => dispatch(getContratti),
})

export default connect(mapStateToProps, mapDispatchToProps)(FindomestiCreaPin)
